import headQuarters from '../../utils/collections/hq';
import { isNullOrEmptyArray } from "../../utils/general";

const availableFilters = () => {
    const arr = [
        { label: 'HQ', key: 'End_Customer_HQ__c', type: 'list', values: headQuarters },
        { label: 'Customer Status', key: 'Customer_Status__c', type: 'list', values: ["Pending", "Approved", "Declined", "Channel Conflict", "In Contact With", "Already a Customer"] },
        { label: 'Opportunity Heat', key: 'Opportunity_Heat__c', type: 'list', values: ["Standard", "Hot"] },
        {
            label: 'ACE Stage', key: 'ACE_Stage__c', type: 'list', values: [
                "Cloud Engagement",
                "Closed Lost",
                "Closed Won",
                "Customer Engagement",
                "Customer Intro",
                "Customer Meeting",
                "Negotiation/Review",
                "Outreach",
                "POV",
                "Prospect",
                "Proposal/Price Quote",
                "Qualification"
            ]
        },
    ];

    return arr;
};

export default availableFilters; 